import React from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

type LeadOpsLayoutProps = {
  children: React.ReactNode;
};

const LeadOpsLayout: React.FC<LeadOpsLayoutProps> = ({ children }) => (
  <Layout className="leadops-layout">
    <Content className="leadops-content">
      {children}
    </Content>
  </Layout>
);

export default LeadOpsLayout;
